module.exports = __webpack_public_path__ + "img/posts.82c718e4.svg";